import ApplicationController from './application_controller'

class CurrencyInputController extends ApplicationController {
  connect () {
    this.element.value = parseFloat(this.element.value || 0).toFixed(2)
  }
}

export default CurrencyInputController
